import { useGetList } from "ra-core";

export interface SmsMessage {
  id: string;
  org_id: string;
  contact_id: string;
  twilio_message_sid: string;
  direction: "inbound" | "outbound";
  from_number: string;
  to_number: string;
  body: string;
  twilio_status: string;
  media_urls: string[];
  created_at: string;
}

export function useSmsThread(contactId: string | undefined) {
  return useGetList<SmsMessage>(
    "sms_messages",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "created_at", order: "ASC" },
      filter: contactId ? { contact_id: contactId } : {},
    },
    { enabled: !!contactId }
  );
}
